var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from 'react';
var useDebouncedEffect = function (callback, delay) {
    if (delay === void 0) { delay = 250; }
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return useEffect.apply(void 0, __spreadArray([function () {
            var timer = setTimeout(callback, delay);
            return function () {
                clearTimeout(timer);
            };
        }], args, false));
};
export default useDebouncedEffect;
